module.exports = __webpack_public_path__ + "img/dcOfflineFlow.4ec2fb21.jpg";